import { Component, inject, Input } from '@angular/core';
import { ContentBuilderVariablesService } from '@shared/utils/content-builder-variables/content-builder-variables.service';

@Component({
  selector: 'app-html-block',
  templateUrl: './html-block.component.html',
  template: ``,
})
export class HtmlBlockComponent {
  private readonly contentBuilderVariablesService = inject(ContentBuilderVariablesService);

  @Input() html?: string;

  protected readonly parseContentBuilderVariables$ = (html: string) => {
    return this.contentBuilderVariablesService.parseContentBuilderString$(html);
  };
}
